import { render, staticRenderFns } from "./IconBonus.vue?vue&type=template&id=85c57b12&"
import script from "./IconBonus.vue?vue&type=script&lang=ts&"
export * from "./IconBonus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports